// Central SEO configuration for the Abacus Design Solutions production site.
export const SITE_URL = "https://abacusds.com";
export const SITE_NAME = "Abacus Design Solutions";
export const DEFAULT_OG_IMAGE =
  "https://vibe.filesafe.space/meta/1785525013889768799/og_image.jpg";

/** Stable Organization @id used by page-level JSON-LD to reference the org. */
export const ORG_ID = `${SITE_URL}/#organization`;

/** Logo used visibly in the footer / brand. */
export const LOGO_URL =
  "https://vibe.filesafe.space/1785525013889768799/attachments/43546f73-a224-41d4-b1bd-db5e389082f1.png";

/**
 * Primary Organization entity.
 *
 * Every value here is sourced from content visibly approved on the site
 * (footer contact block + about page). No street address, founding date,
 * review rating, price range, or service area is invented.
 *
 * Visible facts:
 *  - Legal / display name: "Abacus Interior Decoration Co. W.L.L." /
 *    "Abacus Design Solutions"
 *  - Locality / country: Road 5156, Askar, Kingdom of Bahrain
 *  - Phones: +973 1727 1724, +973 1778 9689
 *  - Email: info@abacusds.com
 *  - Social: Facebook, LinkedIn, YouTube, Instagram (footer)
 */
export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": ORG_ID,
  name: "Abacus Interior Decoration Co. W.L.L.",
  alternateName: "Abacus Design Solutions",
  url: SITE_URL,
  logo: LOGO_URL,
  image: LOGO_URL,
  description:
    "Interior Design & Contracting turn-key solutions provider for commercial, retail, hospitality, F&B and corporate interiors across Bahrain and the GCC.",
  email: "info@abacusds.com",
  telephone: ["+97317271724", "+97317789689"],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Road 5156",
    addressLocality: "Askar",
    addressCountry: "BH",
  },
  sameAs: [
    "https://www.facebook.com/abacusinteriordecoration",
    "https://www.linkedin.com/company/abacus-interior-decoration-co-w-l-l/",
    "https://www.youtube.com/@AbacusInteriorDecoration",
    "https://www.instagram.com/abacusinteriordecoration/",
  ],
};

/** Build an absolute production canonical URL from a root-relative path. */
export function canonicalUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalized === "/" ? "/" : normalized}`;
}

/**
 * Convert a human-readable article date (e.g. "August 24, 2026") into an
 * ISO 8601 date string (e.g. "2026-08-24") for JSON-LD `datePublished`.
 * Returns the original string unchanged if it cannot be parsed, so no
 * invented date is ever emitted.
 */
export function toISODate(humanDate: string): string {
  const parsed = new Date(humanDate);
  if (Number.isNaN(parsed.getTime())) return humanDate;
  return parsed.toISOString().split("T")[0];
}
